import { MenuPermissao } from "../../../stores/PermissionsStore"
import { privateGet } from "../../methods/get"

const basePath = "/menu"

export const obterListaMenuPermissao = () => {
    return privateGet<MenuPermissao[]>(`${basePath}/obterlistamenupermissao`)
}